<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">I would like to thank the Library of Congress for making its collection of Civil War images, documents, and maps available to the public. It is a fascinating experience moving back and forth in time through the various collections so wonderfully preserved. I would also like to thank Caroline (Anderson) Vickerson at Arcadia Publishing for guiding me through the production of this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?08da0eca